import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { v4 as uuid } from 'uuid';
import plantree from '../../assets/data/plan-tree.json';

@Injectable({
  providedIn: 'root'
})
export class ZenplansTestDataProviderService {
  private messageSource = new BehaviorSubject("");
  currentMessage: Observable<string> = this.messageSource.asObservable();
  constructor() {
    let allData = localStorage.getItem("zenplansData");
    if (allData) { this.messageSource.next(allData); }

  }
  changeMessage(message: string) {
    this.messageSource.next(message);
  }

  async getMessage() {
    return await this.currentMessage.toPromise();
  }

  async getSection(sectionName) {
    var myData = {};
    var mySection = [{}];
    let allData = await localStorage.getItem("zenplansData");
    if (allData) {
      myData = JSON.parse(allData);
      mySection = myData[sectionName];
      return mySection;
    }
    return null;
  }

  async getSectionItemNames(sectionName, itemType?) {
    var myData = {};
    var mySection = [{}];
    var itemNames: string[] = [];
    let allData = await localStorage.getItem("zenplansData");
    if (allData) {
      myData = JSON.parse(allData);
      mySection = myData[sectionName];
      if (itemType) {
        mySection.filter(kk => kk["itemType"] == itemType).map(item => {
          itemNames.push(item["itemName"]);
        });
      }
      else {
        mySection.map(item => {
          itemNames.push(item["itemName"]);
        });
      }

      return itemNames;
    }
    return null;
  }

  async getSectionItemIdsAndNames(sectionName, itemType?) {
    var myData = {};
    var mySection = [{}];
    var itemIdsAndNames: [{}] = [{}];
    let allData = await localStorage.getItem("zenplansData");
    if (allData) {
      myData = JSON.parse(allData);
      mySection = myData[sectionName];
      itemIdsAndNames.pop();
      if (itemType) { //for getting all items with a specified itemType
        mySection.filter(kk => kk["itemType"] == itemType).map(item => {
          itemIdsAndNames.push({ "Id": item["Id"], "itemName": item["itemName"] });
        });
      }
      else { //get all items in the section
        mySection.map(item => {
          itemIdsAndNames.push({ "Id": item["Id"], "itemName": item["itemName"] });
        });
      }
      return itemIdsAndNames;
    }
    return null;
  }

  async addItem(myItem, sectionName) {
    let allData = await localStorage.getItem("zenplansData");
    var myData = {};
    var mySection = [{}];
    var item = JSON.parse(myItem);
    if (!allData) {
      allData = "{}"
      await localStorage.setItem("zenplansData", allData);
    }
    if (allData) {
      myData = JSON.parse(allData);
      if (myData) {
        //let sectionIndex = myData.indexOf(sectionName);
        mySection = myData[sectionName];
        item.Id = uuid();
        if (mySection) {
          //item.lastUpdate = JSON.stringify(new Date());
          mySection.push(item);
          myData[sectionName] = mySection;
          await localStorage.setItem("zenplansData", JSON.stringify(myData));
          this.changeMessage(JSON.stringify(myData));
          return item.Id;
        }
        else {
          mySection = [];
          mySection.push(item);
          myData[sectionName] = mySection;
          await localStorage.setItem("zenplansData", JSON.stringify(myData));
          this.changeMessage(JSON.stringify(myData));
          return item.Id;
        }
      }
      else {
        return null;
      }
      return null;
    }
  }

  async updateItem(myItem, sectionName) {
    let allData = localStorage.getItem("zenplansData");
    var myData = {};
    var mySection = [{}];
    var item = JSON.parse(myItem);
    if (allData) {
      myData = JSON.parse(allData);
      if (myData) {
        mySection = myData[sectionName];
        // if (mySection) {
        //   var myIndex = mySection.findIndex(kk => kk["Id"] == item.Id);
        //   mySection[myIndex] = item;
        //   myData[sectionName] = mySection;
        //   localStorage.setItem("zenplansData", JSON.stringify(mySection));
        //   this.changeMessage(JSON.stringify(myData));
        //   return true;
        // }
        if (mySection) {
          var myIndex = mySection.findIndex(kk => kk["Id"] == item["Id"]);
          mySection.splice(myIndex, 1, item);
          myData[sectionName] = mySection;
          await localStorage.setItem("zenplansData", JSON.stringify(myData));
          this.changeMessage(JSON.stringify(myData));
          return true;
        }
      }
      else {
        return null;
      }
      return null;
    }
  }

  async getItem(Id, sectionName) {
    let allData = await localStorage.getItem("zenplansData");
    var myData = {};
    var mySection = [{}];
    if (allData) {
      myData = JSON.parse(allData);
      if (myData) {
        mySection = myData[sectionName];
        if (mySection) {
          var myItem = mySection.find(kk => kk["Id"] == Id);
          return myItem;
        }
      }
      else {
        return null;
      }
      return null;
    }
  }

  async deleteItem(Id, sectionName) {
    let allData = await localStorage.getItem("zenplansData");
    var myData = {};
    var mySection = [{}];
    if (allData) {
      myData = JSON.parse(allData);
      if (myData) {
        mySection = myData[sectionName];
        if (mySection) {
          var myIndex = mySection.findIndex(kk => kk["Id"] == Id);
          mySection.splice(myIndex, 1);
          myData[sectionName] = mySection;
          localStorage.setItem("zenplansData", JSON.stringify(myData));
          this.changeMessage(JSON.stringify(myData));
          return true;
        }
      }
      else {
        return null;
      }
      return null;
    }
  }

  async getSectionItemCount(sectionName) {
    let allData = await localStorage.getItem("zenplansData");
    let myData = {};
    let mySection = [{}];
    if (allData) {
      myData = JSON.parse(allData);
      if (myData) {
        mySection = myData[sectionName];
        if (mySection) {
          return mySection.length;
        }
        else {
          return 0;
        }
      }
      else {
        return 0;
      }
      return 0;
    }
  }
  async getDelegatesCount() {
    let counter = 0;
    let allData = await localStorage.getItem("zenplansData");
    let myData = {};
    let mySection = [{}];
    if (allData) {
      myData = JSON.parse(allData);
      if (myData) {
        if(myData["delegates"]){
        counter = myData["delegates"].length;
        }
      }
    }
    return counter;
  }
  async getAllZenPlanItemCount() {
    let counter = 0;
    let allData = await localStorage.getItem("zenplansData");
    let myData = {};
    let mySection = [{}];
    if (allData) {
      myData = JSON.parse(allData);
      if (myData) {
        for (let i = 0; i < plantree.length; i++) {
          let sections = plantree[i].sections;
          for (let j = 0; j < sections.length; j++) {
            try{
            mySection = myData[sections[j]];
            if (mySection) {
              if(mySection.length){
              counter += mySection.length;
              }
            }
          }
          catch{
            let df = 22;
          }
          }
        }
        return counter;
      }
      else {
        return 0;
      }
      return 0;
    }
    // for(var i=0, len = plantree.length; i<len;i++){
    //   let sections = plantree[i].sections;
    //   for(var j=0, len = sections.length; j<len;j++){
    //     counter +=  await this.getSectionItemCount(sections[j]);
    //   }      
    // }

    // plantree.map(planCategory=>{
    //   planCategory.sections.map(section => {
    //     this.getSectionItemCount(section).then(result=>{
    //       counter += result;
    //     });
    //   });
    // });

    // plantree.forEach(planCategory => {
    //   planCategory.sections.forEach(async section => {
    //     counter += await this.getSectionItemCount(section);
    //   });
    // });
    return counter;
  }

  async getSectionStatus(sectionName) {
    let allData = await localStorage.getItem("zenplansData");
    var myData = {};
    var mySection = [{}];
    var result = {};
    if (allData) {
      myData = JSON.parse(allData);
      if (myData) {
        mySection = myData[sectionName];
        if (mySection) {
          var now = new Date();
          let upToDate = mySection.filter(when => new Date(when["upToDateExpire"]) > now).length;
          let forReview = mySection.filter(when => new Date(when["upToDateExpire"]) <= now).length;
          result = { "upToDate": upToDate, "forReview": forReview };
          return result;
        }
        else {
          return -1;
        }
      }
      else {
        return -1;
      }
      return -1;
    }
  }

  async getPlanCategoryStatus(categoryName) {
    var upToDates = 0, forReviews = 0, missing = 0;
    let mySections2 = plantree.filter(plan => plan.planCategory == categoryName);
    let mySections = plantree.filter(plan => plan["planCategory"] == categoryName)[0]["sections"];
    let allData = await localStorage.getItem("zenplansData");
    var myData = {};
    var mySection = [];
    var result = {};
    var resultsPerSection = [];
    if (allData) {
      myData = JSON.parse(allData);
      if (myData) {
        mySections.map(async section => {
          mySection = myData[section];
          if (mySection) {
            var now = new Date();
            let myUpToDates = mySection.filter(when => new Date(when["upToDateExpire"]) > now).length

            let myForReviews = mySection.filter(when => new Date(when["upToDateExpire"]) <= now).length;
            if (myForReviews > 0) {
              forReviews++;
            }
            if (myForReviews == 0 && myUpToDates > 0) {
              upToDates++;
            }

            if (myForReviews > 0) {
              resultsPerSection.push({ "section": section, "reviewCode": 2 });
            }
            else {
              if (myUpToDates > 0) {
                resultsPerSection.push({ "section": section, "reviewCode": 1 });
              }
              else {
                missing++;
                resultsPerSection.push({ "section": section, "reviewCode": 3 });
              }
            }
          }
          else {
            missing++;
            //we probably want to include sections that have not been marked by the client as "Finished"
            resultsPerSection.push({ "section": section, "reviewCode": 3 });
          }
        });
      }
      result = { "upToDates": upToDates, "forReviews": forReviews, "missing": missing, "reviewCodes": resultsPerSection };
    }
    else {
      result = { "upToDates": 0, "forReviews": 0, "missing": -1, "reviewCodes": [] };
    }
    return result;
  }

  async checkPassword(sectionName, userName, password) {
    let allData = await localStorage.getItem("zenplansData");
    var myData = {};
    var mySection = [{}];
    if (allData) {
      myData = JSON.parse(allData);
      if (myData) {
        mySection = myData[sectionName];
        if (mySection) {
          var myItem = mySection.find(kk => kk["email"] == userName && kk["password"] == password);
          if (myItem) {
            return myItem["Id"];
          }
          else {
            return null;
          }
        }
      }
      else {
        return null;
      }
      return null;
    }
  }
}
